import moment from "moment";
import {Link} from "react-router-dom";
import {isVitrayaInternalUser} from "./UserAuth";

// Solid header so rows don't show through the sticky header while scrolling
export const claimListHeaderStyle = {
    backgroundColor: "#EEF3FB",
    color: "#1F3F7A",
    fontWeight: 700,
    letterSpacing: "0.02em",
    borderBottom: "2px solid #2A5DB4",
    padding: "12px 8px",
    verticalAlign: "middle",
};

export let tableColums = [
    {
        title: "Claim Intimation Number",
        field: "intimationNumber",
        cellStyle: {
            maxWidth: "0.2rem",
        },

        align: "center",
        render: (rowData) =>
            rowData && rowData.intimationNumber ? (
                rowData.intimationNumber
            ) : (
                <span>-</span>
            ),
    },
    {
        title: "Claim Id",
        field: "id",
        cellStyle: {
            maxWidth: "0.04rem",
        },

        align: "center",
        render: (rowData) => (rowData && rowData.id ? rowData.id : <span>-</span>),
    },
    {
        title: "Hospital Name",
        field: "hospitalName",
        cellStyle: {
            maxWidth: "0.3rem",
        },
        align: "center",
        render: (rowData) =>
            rowData && rowData.hospitalName ? (
                <span>{rowData.hospitalName + " - " + rowData.hospitalCode}</span>
            ) : (
                <span>-</span>
            ),
    },
    {
        title: "Status",
        field: "enhancementStatus",
        cellStyle: {
            maxWidth: "0.4rem",
        },

        align: "center",
        render: (rowData) =>
            rowData &&
            rowData.enhancementStatus &&
            (rowData.combinedStatus !== null ? (
                <span style={{maxmaxWidth: "0.5rem"}}>
          {" "}
                    {rowData.enhancementStatus.includes("SUCCESSFUL") ||
                    rowData.enhancementStatus.includes("IN_PROGRESS") ? (
                        <span style={{color: "green"}}>
              {rowData.enhancementStatus.replaceAll("_", " ")}
            </span>
                    ) : rowData.enhancementStatus.includes("FAILED") ? (
                        <span style={{color: "red"}}>
              {rowData.enhancementStatus.replaceAll("_", " ")}
            </span>
                    ) : rowData.enhancementStatus.includes("OUT_OF_SCOPE") ? (
                        <span style={{color: "orange"}}>
              {" "}
                            {rowData.enhancementStatus.replaceAll("_", " ")}
            </span>
                    ) : (
                        rowData.enhancementStatus.replaceAll("_", " ")
                    )}{" "}
        </span>
            ) : (
                "-"
            )),
    },
    {
        title: "Module Status",
        field: "claimCombinedStatus",
        cellStyle: {
            maxWidth: "0.3rem",
        },

        align: "center",
        render: (rowData) =>
            rowData &&
            rowData.combinedStatus &&
            isVitrayaInternalUser() && (
                <span>
          {" "}
                    {
                        rowData.combinedStatus && rowData.adjudicationStatus && rowData.adjudicationStatus.toLowerCase() === "pending"
                            ? (
                                <p style={{color: "orange"}}>In Progress</p>
                            ) : (

                                    rowData.combinedStatus
                                    .split(",")
                                    .map((x, index) =>
                                        x.includes("APPLIED") ||
                                        x.includes("SUCCESSFUL") ||
                                        x.includes("ACCEPTED") ? (
                                            <p key={index} style={{color: "green"}}>
                                                {x.replaceAll("_", " ").toUpperCase()}
                                            </p>
                                        ) : x.includes("FAILED") ||
                                        x.includes("INVALID") ||
                                        x.includes("ERROR") ||
                                        x.includes("out of scope") ||
                                        x.includes("REJECT") ||
                                        x.includes("REJECTED") ? (
                                            <p key={index} style={{color: "red"}}>
                                                {x.replaceAll("_", " ").toUpperCase()}
                                            </p>
                                        ) : x.includes("QUERY") || x.includes("PENDING") ? (
                                            <p key={index} style={{color: "orange"}}>
                                                {x.replaceAll("_", " ").toUpperCase()}
                                            </p>
                                        ) : (
                                            <p key={index}>{x.replaceAll("_", " ").toUpperCase()}</p>
                                        )
                                    )

                                )
                    }
                    {" "}
        </span>
            ),
    },
    {
        title: "Claim Status",
        field: "adjudicationStatus",
        cellStyle: {
            maxWidth: "0.3rem",
        },
        align: "center",
        render: (rowData) =>
            rowData &&
            rowData.adjudicationStatus && (
                <span>
          {rowData.adjudicationStatus === "APPROVED" || rowData.adjudicationStatus.includes('Authorized') ? (
              <p style={{color: "green"}}>{rowData.adjudicationStatus}</p>
          ) : rowData.adjudicationStatus === "PENDING" || rowData.adjudicationStatus.includes('Query') ? (
              <p style={{color: "orange"}}>{rowData.adjudicationStatus}</p>
          ) : (
              <p style={{color: "red"}}>
                  {rowData.adjudicationStatus.replaceAll("_", " ")}
              </p>
          )}
        </span>
            ),
    },
    {
        title: "Reverse Feed Status",
        field: "reverseFeedStatus",
        cellStyle: {
            maxWidth: "0.3rem",
        },
        align: "center",
        render: (rowData) =>
            rowData && rowData.reverseFeedStatus ? (
                rowData.reverseFeedStatus
            ) : (
                <span>NA</span>
            ),
    },
    {
        title: "Claim Type",
        field: "claimType",

        cellStyle: {
            maxWidth: "0.1rem",
        },

        align: "center",
        render: (rowData) =>
            rowData && rowData.claimTransactionType ? (
                rowData.claimTransactionType
            ) : (
                <span>-</span>
            ),
    },
    {
        title: "Procedure Name",
        field: "procedureName",

        cellStyle: {
            maxWidth: "0.1rem",
        },

        align: "center",
        render: (rowData) =>
            rowData && rowData.procedureName ? (
                rowData.procedureName
            ) : (
                <span>-</span>
            ),
    },
    {
        title: "Last Updated Date",
        field: "dateUpdated",

        cellStyle: {
            maxWidth: "0.1rem",
        },

        align: "center",
        render: (rowData) =>
            rowData &&
            rowData.dateUpdated &&
            // isVitrayaInternalUser() && (
            <span style={{maxWidth: "0.1rem"}}>
          {" "}
                {moment(rowData.dateUpdated)
                    .tz("Asia/Kolkata")
                    .format("DD-MM-YYYY, h:mm a")}{" "}
        </span>
        // ),
    },
    {
        title: "Claim Bill Amount Requested",
        field: "claimBillAmountRequested",

        cellStyle: {
            maxWidth: "0.1rem",
        },

        align: "center",
        render: (rowData) =>
            rowData && rowData.claimBillAmountRequested !== null ? (
                <span style={{maxWidth: "0.1rem"}}>
          &#x20b9;{" "}
                    {Math.trunc(rowData.claimBillAmountRequested).toLocaleString("en-IN")}
        </span>
            ) : (
                <span style={{maxWidth: "0.1rem"}}> &#x20b9; 0</span>
            ),
    },
    {
        title: "Amount After Tariff Application",
        field: "amountAfterTariffApplication",

        cellStyle: {
            maxWidth: "0.1rem",
        },

        align: "center",
        render: (rowData) =>
            rowData && rowData.amountAfterTariffApplication !== null ? (
                <span style={{maxWidth: "0.1rem"}}>
          &#x20b9;{" "}
                    {Math.trunc(rowData.amountAfterTariffApplication).toLocaleString(
                        "en-IN"
                    )}{" "}
        </span>
            ) : (
                <span style={{maxWidth: "0.1rem"}}> &#x20b9; 0</span>
            ),
    },
    {
        title: "Amount After Policy Rules Application",
        field: "amountAfterPolicyrulesApplication",
        cellStyle: {
            maxWidth: "0.1rem",
        },

        align: "center",
        render: (rowData) =>
            rowData && rowData.amountAfterPolicyrulesApplication !== null ? (
                <span style={{maxWidth: "0.1rem"}}>
          &#x20b9;{" "}
                    {Math.trunc(rowData.amountAfterPolicyrulesApplication).toLocaleString(
                        "en-IN"
                    )}{" "}
        </span>
            ) : (
                <span style={{maxWidth: "0.1rem"}}> &#x20b9; 0</span>
            ),
    },
    {
        title: "Amount After Medical Admissibility",
        field: "amountAfterMedicalAdmissibility",

        cellStyle: {
            maxmaxWidth: "0.1rem",
        },
        align: "center",
        render: (rowData) =>
            rowData && rowData.amountAfterMedicalAdmissibility !== null ? (
                <span style={{maxWidth: "0.1rem"}}>
          &#x20b9;{" "}
                    {Math.trunc(rowData.amountAfterMedicalAdmissibility).toLocaleString(
                        "en-IN"
                    )}{" "}
        </span>
            ) : (
                <span style={{maxWidth: "0.1rem"}}> &#x20b9; 0</span>
            ),
    },

    {
        title: "Amount Saved",
        field: "amountDeductedInPercent",

        cellStyle: {
            maxWidth: "0.1rem",
        },
        align: "center",
        render: (rowData) =>
            rowData && rowData.amountDeductedInPercent ? (
                <span
                    style={{
                        maxWidth: "0.1rem",
                        color:
                            Math.trunc(rowData.amountDeductedInPercent) > 0
                                ? "green"
                                : "#000",
                    }}
                >
          &#x20b9;{" "}
                    {Math.trunc(rowData.amountDeductedInPercent).toLocaleString("en-IN")}{" "}
                    <br/>
          <b>
            (
              {Math.trunc(
                  (rowData?.amountDeductedInPercent /
                      rowData?.claimBillAmountRequested) *
                  100
              )}
              % )
          </b>
        </span>
            ) : (
                <span> &#x20b9; 0</span>
            ),
    },
    {
        title: "View Details",
        field: "id",

        cellStyle: {
            maxWidth: "0.1rem",
        },

        align: "center",
        render: (rowData) =>
            rowData &&
            rowData.id && (
                <span style={{maxWidth: "0.1rem"}}>
          <Link to={`/claim/${rowData.id}`} target="_blank">
            Click Here
          </Link>
        </span>
            ),
    },
];
